import React from 'react';

const ForbiddenAccess = () => {
  return <div>Accès refusé</div>;
};

export default ForbiddenAccess;
